"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = ["colspan"];
const _hoisted_3 = { class: "px-4 py-2" };
const _hoisted_4 = {
    key: 0,
    class: "px-4 py-2 lg:ml-2"
};
const _hoisted_5 = {
    key: 0,
    class: "text-xs"
};
const _hoisted_6 = {
    key: 1,
    class: "text-xs"
};
const _hoisted_7 = {
    key: 1,
    class: "px-4 py-2 lg:ml-2"
};
const _hoisted_8 = {
    key: 0,
    class: "text-xs"
};
const _hoisted_9 = {
    key: 1,
    class: "text-xs"
};
const _hoisted_10 = { class: "px-4 py-2 lg:ml-2" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "px-4 py-2" }, null, -1);
const _hoisted_12 = ["id"];
const _hoisted_13 = { class: "px-4 py-2 grid grid-cols-2 lg:flex-none lg:text-left w-full border-b border-gray lg:border-none" };
const _hoisted_14 = { class: "lg:hidden" };
const _hoisted_15 = {
    key: 0,
    class: "px-4 py-2 lg:ml-2 grid grid-cols-2 lg:flex-none lg:text-left w-full border-b border-gray lg:border-none"
};
const _hoisted_16 = { class: "lg:hidden" };
const _hoisted_17 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_18 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_19 = {
    key: 1,
    class: "px-4 py-2 lg:ml-2 grid grid-cols-2 lg:flex-none lg:text-left w-full border-b border-gray lg:border-none"
};
const _hoisted_20 = { class: "lg:hidden" };
const _hoisted_21 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_22 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_23 = { class: "px-4 py-2 lg:ml-2 grid grid-cols-2 lg:flex-none lg:text-left w-full border-b border-gray lg:border-none" };
const _hoisted_24 = { class: "lg:hidden" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { class: "px-4 py-2 font-normal grid grid-cols-2 lg:flex-none lg:text-left w-full" };
const _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, null, -1);
const _hoisted_29 = { class: "flex justify-end" };
const _hoisted_30 = { class: "flex gap-0 justify-end items-center bg-gray w-28 h-10 mr-0 ml-auto" };
const _hoisted_31 = ["id", "onKeyup", "onWheel"];
const _hoisted_32 = ["for"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-shopping_cart add-to-cart" }, null, -1);
const _hoisted_35 = {
    key: 0,
    class: "absolute text-white text-base bg-gray-darker p-1 rounded z-10 leading-none -right-2"
};
const tagStore_1 = require("../../../stores/tag/tagStore");
const cartsStore_1 = require("../../../stores/carts/cartsStore");
const toastStore_1 = require("../../../stores/toast/toastStore");
const vue_router_1 = require("vue-router");
const i18n_1 = require("../../../common/i18n");
const shop_1 = require("../../../common/utils/shop");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PriceOptionsRow',
    props: {
        product: null,
        visiblePriceOptions: null,
        tableId: null
    },
    setup(__props) {
        const props = __props;
        const tagStore = (0, tagStore_1.useTagStore)();
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const stockMax = 50;
        const priceCellWidth = (0, vue_3.computed)(() => {
            var _a;
            if ((_a = tagStore.tags.switches.customPriceSwitch) === null || _a === void 0 ? void 0 : _a.value) {
                return customPriceWidth.value;
            }
            return tagStore.tags.switches.retailPriceSwitch.value ? retailPriceWidth.value : wholesalePriceWidth.value;
        });
        const stockCellWidth = (0, vue_3.computed)(() => stockWidth.value);
        const cartCellWidth = (0, vue_3.computed)(() => cartWidth.value);
        const gridTemplateColsStyle = (0, vue_3.computed)(() => ({
            gridTemplateColumns: `auto ${priceCellWidth.value} ${stockCellWidth.value} ${cartCellWidth.value}`
        }));
        const wholesalePriceWidth = (0, vue_3.ref)("auto");
        const retailPriceWidth = (0, vue_3.ref)("auto");
        const customPriceWidth = (0, vue_3.ref)("auto");
        const stockWidth = (0, vue_3.ref)("auto");
        const cartWidth = (0, vue_3.ref)("auto");
        const addToCartButton = async (productId, product) => {
            try {
                let inputId = 'quantity-' + productId;
                let input = document.getElementById(inputId);
                let quantity = 0;
                if (input instanceof HTMLInputElement) {
                    quantity = parseInt(input.value ? input.value : "0");
                }
                await cartsStore.addProduct(router, quantity, productId);
                if (input instanceof HTMLInputElement) {
                    input.value = "";
                }
                if (quantity === 0) {
                    return;
                }
                const { prices } = product;
                const totalValue = quantity * prices.priceNet;
                const gtagData = {
                    currency: prices.currencyCode,
                    value: totalValue,
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.productName,
                            price: prices.priceNet,
                            quantity: quantity,
                        },
                    ],
                };
                gtag("event", "add_to_cart", gtagData);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const quantityScrollHandler = (event, productId) => {
            let input = document.getElementById('quantity-' + productId);
            if (!input)
                return;
            let current = Number(input.value) || 0;
            if (event.deltaY < 0) {
                // fel +4
                current += 4;
            }
            else if (event.deltaY > 0) {
                // le -1
                current -= 1;
            }
            current = Math.max(0, Math.min(100, current));
            input.value = String(current);
        };
        const recalcWidths = () => {
            const wholesaleEl = document.getElementById(`${props.tableId}-wholesale-price-header-cell`);
            const retailEl = document.getElementById(`${props.tableId}-retail-price-header-cell`);
            const customEl = document.getElementById(`${props.tableId}-custom-price-header-cell`);
            const stockEl = document.getElementById(`${props.tableId}-stock-header-cell`);
            const cartEl = document.getElementById(`${props.tableId}-cart-header-cell`);
            if (wholesaleEl)
                wholesalePriceWidth.value = `${wholesaleEl.clientWidth}px`;
            if (retailEl)
                retailPriceWidth.value = `${retailEl.clientWidth}px`;
            if (customEl)
                customPriceWidth.value = `${customEl.clientWidth}px`;
            if (stockEl)
                stockWidth.value = `${stockEl.clientWidth}px`;
            if (cartEl)
                cartWidth.value = `${cartEl.clientWidth}px`;
        };
        const isStockMax = (stocks) => {
            return stocks > stockMax;
        };
        (0, vue_3.onMounted)(() => {
            (0, vue_3.nextTick)().then(recalcWidths);
            window.addEventListener('resize', recalcWidths);
            window.addEventListener(`${props.tableId}-header-widths-changed`, recalcWidths);
            window.addEventListener('price-table-header-widths-changed', recalcWidths);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            window.removeEventListener('resize', recalcWidths);
            window.removeEventListener(`${props.tableId}-header-widths-changed`, recalcWidths);
            window.removeEventListener('price-table-header-widths-changed', recalcWidths);
        });
        (0, vue_3.watch)(() => tagStore.tags.switches.retailPriceSwitch.value, async () => {
            await (0, vue_3.nextTick)();
            recalcWidths();
        });
        (0, vue_3.watch)(() => { var _a; return (_a = tagStore.tags.switches.customPriceSwitch) === null || _a === void 0 ? void 0 : _a.value; }, async () => {
            await (0, vue_3.nextTick)();
            recalcWidths();
        });
        (0, vue_3.watch)(() => tagStore.activeColumnCount, async () => {
            await (0, vue_3.nextTick)();
            recalcWidths();
        });
        (0, vue_3.watch)(props.visiblePriceOptions, async () => {
            await (0, vue_3.nextTick)();
            recalcWidths();
        });
        return (_ctx, _cache) => {
            return (__props.visiblePriceOptions.get(__props.product.id))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                    key: 0,
                    id: `price-options-row-${__props.product.id}`
                }, [
                    (0, vue_2.createElementVNode)("td", {
                        colspan: (0, vue_2.unref)(tagStore).activeColumnCount,
                        class: "p-2 bg-gray-light"
                    }, [
                        (0, vue_2.createElementVNode)("div", {
                            class: "price-options-header-line hidden lg:grid lg:grid-cols-4 text-left font-bold text-black cursor-pointer lg:items-center text-sm",
                            style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(gridTemplateColsStyle))
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('shipping', 'Shipping', 'price_options_row')), 1),
                            (!(0, vue_2.unref)(tagStore).tags.switches.retailPriceSwitch.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('wholesale_price', 'Wholesale price', 'price_options_row')) + " ", 1),
                                    ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('gross', 'gross', 'price_options_row')), 1))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('net', 'net', 'price_options_row')), 1))
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('retail_price', 'Retail price', 'price_options_row')) + " ", 1),
                                    ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('gross', 'gross', 'price_options_row')), 1))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('net', 'net', 'price_options_row')), 1))
                                ])),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('stock', 'Stock', 'price_options_row')), 1),
                            _hoisted_11
                        ], 4),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.product.priceOptions, (priceOption) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: priceOption.code,
                                id: `price-options-row-product-${priceOption.id}`,
                                class: "price-options-data-line flex flex-col lg:grid lg:grid-cols-4 border-b border-gray-dark last:border-0 items-center font-bold bg-white text-sm",
                                style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(gridTemplateColsStyle))
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('shipping', 'Shipping', 'price_options_row')), 1),
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(priceOption.dateInDays), 1)
                                ]),
                                (!(0, vue_2.unref)(tagStore).tags.switches.retailPriceSwitch.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('price', 'Wholesale price', 'price_options_row')), 1),
                                        ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(priceOption.priceNet, priceOption.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(priceOption.priceNet, priceOption.currencyCode)), 1))
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('retail_price', 'Retail price', 'price_options_row')), 1),
                                        ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(priceOption.priceNetRetail, priceOption.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(priceOption.priceNetRetail, priceOption.currencyCode)), 1))
                                    ])),
                                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('stock', 'Stock', 'price_options_row')), 1),
                                    (isStockMax(priceOption.stock))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, (0, vue_2.toDisplayString)(stockMax) + "+ "))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_26, (0, vue_2.toDisplayString)(priceOption.stock), 1))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                    _hoisted_28,
                                    (0, vue_2.createElementVNode)("span", _hoisted_29, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                            (0, vue_2.createElementVNode)("input", {
                                                id: 'quantity-' + priceOption.id,
                                                class: "quantity h-full text-center aspect-square block w-10 bg-gray",
                                                type: "number",
                                                min: "0",
                                                max: "100",
                                                placeholder: "0",
                                                onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(() => { }, ["stop"])),
                                                onKeyup: (0, vue_2.withKeys)(($event) => (addToCartButton(priceOption.id, __props.product)), ["enter"]),
                                                onWheel: (0, vue_2.withModifiers)(($event) => (quantityScrollHandler($event, priceOption.id)), ["prevent"])
                                            }, null, 40, _hoisted_31),
                                            (0, vue_2.createElementVNode)("label", {
                                                for: 'quantity-' + __props.product.id,
                                                class: "flex pr-1 items-center justify-center h-full font-bold text-center w-10",
                                                onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('short_unit', 'pc.', 'price_options_row')), 9, _hoisted_32),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                class: "aspect-square add-to-cart btn btn-primary btn-cart relative",
                                                onClick: ($event) => (addToCartButton(priceOption.id, __props.product))
                                            }, [
                                                _hoisted_34,
                                                ((0, vue_2.unref)(cartsStore).activeCart && 0 < (0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(priceOption.id))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("sup", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(priceOption.id)), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ], 8, _hoisted_33)
                                        ])
                                    ])
                                ])
                            ], 12, _hoisted_12));
                        }), 128))
                    ], 8, _hoisted_2)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
